import AnimationClip from '../AnimationClip';
import { Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import TransformComponent from '../../../Component/Transform';

export class BonusText extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform = gameObject.getComponent(TransformComponent);
        const renderable: Renderable = gameObject.getComponent<Renderable>(
            Renderable
        );
        const tweenPosition = this.getTween(transform.position);
        const tweenAlpha = this.getTween(renderable);
        const duration = 1000;

        tweenPosition
            .to({ y: transform.y - 100 }, duration * 0.75)
            .easing(Easing.Cubic.Out);

        yield* this.startTween(tweenPosition);

        tweenAlpha.to({ alpha: 0 }, duration * 0.25);

        yield* this.startTween(tweenAlpha);

        gameObject.destroy();
    }
}
